<div class="row">
    <div class="col-lg-6 col-xl-6 mb-3 mx-auto" *ngFor="let source of dashboardData.data.sources">
        <div class="totals-box shortAnim {{ source.boxClass }} active"> <!-- (click)="toggleChartLine(source)" [ngClass]="{ 'active' : source.visible }" -->
            <div class="totals-content">
                <div class="totals-name">
                    {{ source.name | translate }}
                </div>
                <div class="totals-value">
                    <ng-container *ngIf="source.value == 'ordersValue'">
                        {{ utilityService.thousandSeparator(dashboardData.data.totals[ source.value ]) }}
                    </ng-container>
                    <ng-container *ngIf="source.value != 'ordersValue'">
                        {{ dashboardData.data.totals[ source.value ] }}
                    </ng-container>
                </div>
            </div>
            <div class="totals-icon {{ source.class }}">
                <mat-icon>{{ source.icon }}</mat-icon>
            </div>
        </div>
    </div>
    <div class="col-12 col-xl-6">
        <div class="chart-container">
            <dx-chart #chart [dataSource]="dashboardData.data.values" (onPointClick)="pointClick($event)" (onLegendClick)="legendClick($event)">
            
                <dxi-series *ngFor="let source of dashboardData.data.sources" [valueField]="source.value" [name]="source.name | translate" [visible]="source.visible" [color]="source.color"></dxi-series>
                <dxo-common-series-settings #seriesSettings argumentField="status" type="bar" selectionMode="allArgumentPoints">
                    <dxo-label [visible]="true"></dxo-label>
                </dxo-common-series-settings>
            
                <dxo-argument-axis [valueMarginsEnabled]="true" discreteAxisDivisionMode="crossLabels">
                    <dxo-grid [visible]="true"></dxo-grid>
                    <dxo-label [customizeText]="customizeText"></dxo-label>  
                </dxo-argument-axis>
            
                <dxo-title [text]="dashboardData.translated"></dxo-title>
                <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="bottom">
                </dxo-legend>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-tooltip [enabled]="true"></dxo-tooltip>
                <!-- <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                <dxo-scroll-bar [visible]="true" [opacity]="0.5" [width]="6"></dxo-scroll-bar> -->
            </dx-chart>
        </div>
    </div>
    <div class="col-12 col-xl-6">
        <app-orders-by-delivery-status [dashboardData]="dashboardDataDelivery"></app-orders-by-delivery-status>
    </div>
</div>